import NewHeader from "../components/NewHeader_dev";
import DownloadCSS from "./Download.module.css";
import Footer from "../components/Footer";
import Loader from '../components/Loader';
import React,{useState,useEffect} from 'react';

function Download() {
  const imagestyle = {
      height: "180px",
      width: "180px",
  };
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);
  return (
    <div className={DownloadCSS.content}>
      <NewHeader />
      <br />
      <br />

          <div className={DownloadCSS.titletext}>- Application for Windows -</div>
          <div className={DownloadCSS.userparent5}>
              <div className={DownloadCSS.userwrap5}>
                  <div className={DownloadCSS.userimage5}>
                      <a href="/download/windows.zip" download><img src="https://www.smartooth.co/img/download_smartoothservice_windows.png" alt="Smartooth Windows Service" width="230px" /></a>
                  </div>
                  <div className={DownloadCSS.usertext5}>
                      <a href="/download/windows.zip" download><p>Version 1.1.1</p></a>
                  </div>
              </div>
              <div className={DownloadCSS.userwrap5}>
                  <div className={DownloadCSS.rect_ani}>
                  <img src="https://www.smartooth.co/img/bg_rect_dp2.png" alt="smartooth" width="230px" />
                      <br/><br/><p><a href="https://www.smartooth.co/download/smartooth_animalservice_windows_20260731_kor.pdf" download>매뉴얼(사용자 가이드)</a></p>
                </div> 
                <div className={DownloadCSS.userimage5}>
                      <a href="/download/SmartoothAnimalServiceInstaller.1.0.1.zip" download><img src="https://www.smartooth.co/img/download_animalservice_windows.png" alt="Smartooth Windows Service" width="230px" /></a>
                  </div>
                  <div className={DownloadCSS.usertext5}>
                      <a href="/download/SmartoothAnimalServiceInstaller.1.0.1.zip" download><p>Version 1.0.1</p></a>
                  </div>
              </div>
              <div className={DownloadCSS.userwrap5}>
                  <div className={DownloadCSS.userimage5}>
                      <a href="/download/SmartoothDentistSetup_101.zip" download><img src="https://www.smartooth.co/img/download_dent_windows.png" alt="Smartooth Windows Service" width="230px" /></a>
                  </div>
                  <div className={DownloadCSS.usertext5}>
                      <a href="/download/SmartoothDentistSetup_101.zip" download><p>Version 1.0.1</p></a>
                  </div>
              </div>
          </div>
          <div className={DownloadCSS.titletext}>- Applications for Android Tablet -</div>
        <div className={DownloadCSS.userparent1}>
            <div className={DownloadCSS.userwrap1}>
                <div className={DownloadCSS.userimage1}>
                      <a href="/download/smartooth_dental_hospital.apk" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_dent_eng.png" alt="Smartooth" width="230px" /></a>
                </div>
                <div className={DownloadCSS.usertext1}>
                    <p>Version 1.2.11</p>
                </div>
                <div className={DownloadCSS.rect1}>
                    <a href="/download/기기 및 SW 소개 ver.1.6_20230821.pdf" download>
                      <img src="https://www.smartooth.co/img/bg_rect_dent.png" alt="rect" width="230px" />
                      <p>매뉴얼(기기 및 SW 소개)</p>
                      <p>DOWNLOAD</p>
                    </a>
                </div> 
                <div className={DownloadCSS.rect2}>
                    <a href="/download/어플리케이션 설치 조건 및 방법 ver.1.1_20230720.pdf" download>
                        <img src="https://www.smartooth.co/img/bg_rect_dent.png" alt="rect" width="230px" />
                        <p>어플리케이션 설치 방법</p>
                        <p>DOWNLOAD</p>
                    </a>
                </div>  
                <div className={DownloadCSS.rect3}>
                    <a href="/download/디스플레이 기기 사용 매뉴얼 ver1.4_20230720.pdf" download>
                        <img src="https://www.smartooth.co/img/bg_rect_dent.png" alt="rect" width="230px" />
                        <p>디스플레이 메뉴얼</p>
                        <p>DOWNLOAD</p>
                    </a>
                </div>     
            </div>
            <div className={DownloadCSS.userwrap1}>
                <div className={DownloadCSS.userimage1}>
                      <a href="/download/smartooth_phc_service_121_20260827.apk" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_healthcare.png" alt="Smartooth" width="230px" /></a>
                </div>
                <div className={DownloadCSS.usertext1}>
                    <p>PublicHealthCenter<br/>Version 1.2.1</p>
                </div>
            </div>
              <div className={DownloadCSS.userwrap1}>
                  <div className={DownloadCSS.userimage1}>
                      <a href="/download/smartooth_school_service_20240711_1.2.8.apk" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_kinder.png" alt="Smartooth" width="230px" /></a>
                  </div>
                  <div className={DownloadCSS.usertext1}>
                      <p>Version 1.2.8</p>
                  </div>
              </div>
        </div>
        <div className={DownloadCSS.userparent1}>
            <div className={DownloadCSS.userwrap1}>
                <div className={DownloadCSS.userimage1}>
                    <a href="/download/smartooth_dpapp_20250717.apk" target="_blank" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_dpapp.png" alt="Smartooth" width="230px" /></a>
                </div>
                <div className={DownloadCSS.usertext1}>
                    <p>Version 1.0.7</p>
                </div>
                <div className={DownloadCSS.rect1}>
                    <a href="https://apps.apple.com/kr/app/smartooth-dp/id6670414479" target="_blank" download>
                        <img src="https://www.smartooth.co/img/bg_rect_dp2.png" alt="rect" width="230px" />
                        <p>IOS App Donwload</p>
                        <p>DOWNLOAD</p>
                    </a>
                </div>     
            </div>
            <div className={DownloadCSS.userwrap1}>
                <div className={DownloadCSS.userimage1}>
                      <a href="/download/smartooth_20250915.apk" target="_blank" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_general.png" alt="Smartooth" width="230px" /></a>
                </div>
                <div className={DownloadCSS.usertext1}>
                    <p>Version 1.0.6</p>
                </div>
                <div className={DownloadCSS.rect1}>
                    <a href="/download/Introduction to Devices & SW_2024.pdf" download>
                      <img src="https://www.smartooth.co/img/bg_rect_dp2.png" alt="rect" width="230px" />
                      <p>디바이스 & SW 소개</p>
                      <p>DOWNLOAD</p>
                    </a>
                </div>       
            </div>
            <div className={DownloadCSS.userwrap1}>
                <div className={DownloadCSS.userimage1}>
                <a href="/download/smartooth_school_service_20250513_2.apk" type="application/vnd.android.package-achive" download><img src="https://www.smartooth.co/img/download_school.png" alt="Smartooth" width="230px" /></a>
                </div>
                <div className={DownloadCSS.usertext1}>
                    <p>Version 1.0.3</p>
                </div>    
            </div>
          </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      <Footer />
    </div>
  );
}
export default Download;